export default "__VITE_ASSET__B82dgKln__"